import AbstractShape, {Dimensions, DimensionProperties} from "./AbstractShape";
import Length from "../../../../source/js/shared/models/Geometry/Length";
import DimensionLine from "../Lines/DimensionLine";
import OffsetLine from "../Lines/OffsetLine";
import { IPoint } from "makerjs";

export class QuarterCircle extends AbstractShape {
	constructor( dimensions?: object ) {
		super( 'quarter-circle', dimensions );
	}

	getRadius(): Length {
		return this.cleanedPrimitives.radius;
	}

	getLength(): Length {
		return this.cleanedPrimitives.radius;
	}

	getWidth(): Length {
		return this.cleanedPrimitives.radius;
	}

	getHeight(): Length {
		return this.cleanedPrimitives.radius;
	}

	getDimensionProperties(): DimensionProperties {
		return { primary: 'radius' };
	}

	getDimensionLines(ratio = 1, focusedElement = '', forceRender = false): DimensionLine[] {
		if(focusedElement.includes("cutout_measurement") || forceRender) {
			return [
				new DimensionLine( [0, 0], [ this.getLength().in_mm(), 0 ], this.renderDimensionLabel( 'radius', this.getLength().in_cm() ), [0, -40], ratio, this.getDimensionLineType('measurements-quarter-circle-radius', focusedElement, forceRender) ),
			];
		}

		return [];
	}

	getDefaultDimensions(): Dimensions {
		return { radius: 25 };
	}

	getDefaultCutoutDimensions(parentShape: AbstractShape): Dimensions {
		const enclosingRectangle = parentShape.getEnclosingRectangle();
		const width = enclosingRectangle.width();

		return {
			radius: width.divide(2).in_cm(),
		};
	}
}
